import { ITranslationProjectTranslationItem } from 'types/translationProject';

type RendererParams = {
  data?: Pick<ITranslationProjectTranslationItem, 'item_info'>;
};

export function translationItemInfoRenderer(params: RendererParams) {
  if (!params.data || !params.data.item_info) {
    return '<span style="color: #999;">N/A</span>';
  }

  const itemInfo = params.data.item_info;
  const sourceText = itemInfo.source_text || '';
  const sourceDialectCode = itemInfo.source_dialect_code || '';
  const targetText = itemInfo.target_text || '';
  const targetDialectCode = itemInfo.target_dialect_code || '';

  let html = '<div style="padding: 6px 0;">';

  // Source translation (display as innerHTML to preserve formatting tags)
  html += `
    <div style="
      padding: 6px 10px;
      background-color: #f5f5f5;
      border-left: 3px solid #2196f3;
      border-radius: 3px;
      margin-bottom: 6px;
      line-height: 1.4;
    ">
      <strong>${escapeHtml(sourceDialectCode)}:</strong> ${sourceText || 'N/A'}
    </div>
  `;

  // Target translation (display as innerHTML to preserve formatting tags)
  html += `
    <div style="
      padding: 6px 10px;
      background-color: #f5f5f5;
      border-left: 3px solid #4caf50;
      border-radius: 3px;
      line-height: 1.4;
    ">
      <strong>${escapeHtml(targetDialectCode)}:</strong> ${targetText || 'N/A'}
    </div>
  `;

  html += '</div>';
  return html;
}

function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}
